module.exports = __webpack_public_path__ + "media/images/diy/review_photo_two-101aa5444b1be8c85cfffaca9573b7bf.svg";